import React from 'react';
import { cn } from '@/lib/utils';

const GhostButton = React.forwardRef(({ 
  className, 
  children, 
  disabled = false,
  onClick,
  type = 'button',
  size = 'md',
  ...props 
}, ref) => {
  const sizeClasses = {
    sm: 'h-[28px] px-3 text-xs',
    md: 'h-[36px] px-4 text-sm',
    lg: 'h-[44px] px-5 text-base'
  };

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center gap-2',
        'rounded-[var(--radius-md)] font-medium font-["Sora"]',
        'transition-all duration-180',
        'focus-ring',
        'interactive',
        !disabled && 'hover:bg-[rgba(61,90,128,0.08)]',
        !disabled && 'active:scale-[0.98]',
        disabled && 'disabled opacity-50 cursor-not-allowed',
        sizeClasses[size],
        className
      )}
      style={{
        color: 'var(--color-slate)'
      }}
      data-testid={props['data-testid']}
      {...props}
    >
      {children}
    </button>
  );
});

GhostButton.displayName = 'GhostButton';

export { GhostButton };